import { render, staticRenderFns } from "./AddManualPointPopup.vue?vue&type=template&id=1f4a1490&scoped=true&"
import script from "./AddManualPointPopup.vue?vue&type=script&lang=js&"
export * from "./AddManualPointPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddManualPointPopup.vue?vue&type=style&index=0&id=1f4a1490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a1490",
  null
  
)

export default component.exports